// Test Firebase integration with all 3 collections
import firebaseService from './firebaseService';
import { proverbApiService } from './proverbApiService';

// Test Firebase Integration
export const testFirebaseIntegration = async () => {
  console.log('🧪 Testing Firebase Integration...');
  
  try {
    // Test 1: Get proverbs from Firebase (should show 102 proverbs)
    console.log('\\n1. Testing Proverbs Collection:');
    const proverbs = await proverbApiService.getAllProverbsFromFirebase();
    console.log(`✅ Found ${proverbs.proverbs.length} proverbs in Firebase`);
    
    if (proverbs.proverbs.length > 0) {
      console.log('First proverb:', proverbs.proverbs[0].chinese_proverb);
    }

    // Test 2: Log an activity
    console.log('\\n2. Testing Activities Collection:');
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (user.id) {
      await firebaseService.utils.logUserActivity(
        user.id.toString(), 
        user.name || 'Test User', 
        'FIREBASE_TEST', 
        { 
          testType: 'integration_test',
          timestamp: new Date().toISOString(),
          proverbs_found: proverbs.proverbs.length
        }
      );
      console.log('✅ Activity logged to Firebase');
    }

    // Get recent activities
    const activities = await firebaseService.activities.getRecentActivities(10);
    console.log(`✅ Found ${activities.length} recent activities`);

    // Test 3: Get voice collection info
    console.log('\\n3. Testing Voice Collection:');
    const voices = await firebaseService.voice.getAllVoices();
    console.log(`✅ Found ${voices.length} voice files in Firebase`);

    // Test 4: Dashboard stats
    console.log('\\n4. Testing Dashboard Stats:');
    const stats = await firebaseService.utils.getDashboardStats();
    console.log(`✅ Dashboard stats:`, {
      totalProverbs: stats.totalProverbs,
      totalActivities: stats.totalActivities,
      totalVoices: stats.totalVoices
    });

    return {
      success: true,
      stats: {
        proverbs: proverbs.proverbs.length,
        activities: activities.length,
        voices: voices.length
      }
    };

  } catch (error) {
    console.error('❌ Firebase integration test failed:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

// Test specific proverb voice upload
export const testVoiceUpload = async (proverbId, audioFile) => {
  try {
    console.log('🎤 Testing voice upload for proverb:', proverbId);
    
    const result = await proverbApiService.uploadVoiceForProverb(proverbId, audioFile, {
      description: 'Test upload from dashboard',
      language: 'chinese',
      quality: 'high'
    });
    
    console.log('✅ Voice uploaded successfully:', result);
    return result;
  } catch (error) {
    console.error('❌ Voice upload test failed:', error);
    throw error;
  }
};

// Check Firebase connection status
export const checkFirebaseConnection = async () => {
  try {
    console.log('🔗 Checking Firebase connection...');
    
    // Simple test to see if we can read from Firebase
    const testRef = await firebaseService.proverbs.getAllProverbs();
    
    return {
      connected: true,
      message: '✅ Firebase connection successful',
      proverbCount: testRef.length
    };
  } catch (error) {
    return {
      connected: false,
      message: '❌ Firebase connection failed',
      error: error.message
    };
  }
};

const firebaseTestService = {
  testFirebaseIntegration,
  testVoiceUpload,
  checkFirebaseConnection
};

export default firebaseTestService;
